import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=437f9d80&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=437f9d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437f9d80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('437f9d80')) {
      api.createRecord('437f9d80', component.options)
    } else {
      api.reload('437f9d80', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=437f9d80&scoped=true&", function () {
      api.rerender('437f9d80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qc23xah3NoK0/JS/comp/SearchFilterTokens.vue"
export default component.exports